import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'
import _imports_1 from '@/assets/icons/thin-plus.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-16bbabd0")

_pushScopeId("data-v-16bbabd0")
const _hoisted_1 = { class: "business-receipt-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "receipt-switcher-add-payment" }
const _hoisted_4 = { class: "receipt-switcher" }
const _hoisted_5 = { class: "switcher-payments" }
const _hoisted_6 = { class: "switcher-payments" }
const _hoisted_7 = { class: "payments-block container" }
const _hoisted_8 = {
  key: 0,
  class: "payment-item"
}
const _hoisted_9 = { class: "payment-item-type" }
const _hoisted_10 = { class: "payment-table" }
const _hoisted_11 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("span", null, "#")
], -1)
const _hoisted_12 = { class: "action-column" }
const _hoisted_13 = { class: "action-btns" }
const _hoisted_14 = {
  key: 1,
  class: "payment-item"
}
const _hoisted_15 = { class: "payment-item-type" }
const _hoisted_16 = { class: "payment-table" }
const _hoisted_17 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("span", null, "#")
], -1)
const _hoisted_18 = { class: "action-column" }
const _hoisted_19 = { class: "action-btns" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_21 = {
  key: 2,
  class: "payment-item"
}
const _hoisted_22 = { class: "payment-item-type" }
const _hoisted_23 = { class: "payment-table" }
const _hoisted_24 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("span", null, "#")
], -1)
const _hoisted_25 = { class: "bankName" }
const _hoisted_26 = { class: "action-column" }
const _hoisted_27 = { class: "action-btns" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_29 = {
  key: 3,
  class: "payment-item"
}
const _hoisted_30 = { class: "payment-item-type" }
const _hoisted_31 = { class: "payment-table" }
const _hoisted_32 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("span", null, "#")
], -1)
const _hoisted_33 = { class: "bankName" }
const _hoisted_34 = { class: "action-column" }
const _hoisted_35 = { class: "action-btns" }
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "container container-total-row"
}
const _hoisted_38 = { class: "container-total-row-item" }
const _hoisted_39 = {
  class: "container",
  style: {"color":"#354052","font-size":"24px","padding-top":"20px"}
}
const _hoisted_40 = { class: "container" }
const _hoisted_41 = {
  id: "desktop-grid",
  class: "desktop-grid"
}
const _hoisted_42 = {
  id: "main-table",
  class: "main-table receipt-invoice-table"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 1,
  class: "thead-last-td"
}
const _hoisted_45 = { class: "add-order-product-customer-row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 1,
  class: "last-child"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "border-footer" }
const _hoisted_53 = { class: "border-footer" }
const _hoisted_54 = {
  key: 0,
  class: "border-footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DocumentHeader = _resolveComponent("DocumentHeader")
  const _component_BusinessAccountingForTo = _resolveComponent("BusinessAccountingForTo")
  const _component_router_link = _resolveComponent("router-link")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_BusinessReceiptInvoicesModal = _resolveComponent("BusinessReceiptInvoicesModal")
  const _component_BusinessReceiptPaymentModal = _resolveComponent("BusinessReceiptPaymentModal")
  const _component_BusinessReceiptPelecardPaymentModal = _resolveComponent("BusinessReceiptPelecardPaymentModal")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
    id: "receipt-form-id",
    novalidate: ""
  }, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_DocumentHeader, {
        name: _ctx.receiptHeader,
        editMode: _ctx.editMode,
        onBack: _ctx.cancel,
        showViewPdf: !_ctx.isNew && !_ctx.editMode,
        showShare: !_ctx.isNew && !_ctx.editMode,
        isNew: _ctx.isNew,
        onShareDocument: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shareDocument())),
        onViewPdfDocument: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewPdfDocument())),
        onEdit: _ctx.edit,
        hideEdit: _ctx.orderId != '' && !_ctx.isNew,
        form: 'receipt-form-id',
        leftToPay: _ctx.orderLeftToPayComputed,
        showLeftToPay: _ctx.isNew,
        currencySign: _ctx.orderCurrencySymbol,
        showCancelDocument: _ctx.hasCancelExistingReceiptPermission && _ctx.orderId != '' && !_ctx.isNew && _ctx.receiptId != '' && _ctx.paymentsTotalAmount > 0,
        cancelButtonText: _ctx.$t('cancelReceipt.cancel-receipt-link'),
        onCancelDocument: _ctx.cancelExistReceipt
      }, null, 8, ["name", "editMode", "onBack", "showViewPdf", "showShare", "isNew", "onEdit", "hideEdit", "leftToPay", "showLeftToPay", "currencySign", "showCancelDocument", "cancelButtonText", "onCancelDocument"]),
      _createVNode(_component_BusinessAccountingForTo, {
        editMode: _ctx.editMode,
        isNew: _ctx.isNew,
        recipientNameProp: _ctx.receipt.recipientName,
        forProp: _ctx.receipt.for,
        createdDate: _ctx.receipt.createdDate,
        "issue-date": _ctx.receipt.createdDate,
        onUpdateRecipientName: _ctx.updateRecipientName,
        onUpdateFor: _ctx.updateFor
      }, null, 8, ["editMode", "isNew", "recipientNameProp", "forProp", "createdDate", "issue-date", "onUpdateRecipientName", "onUpdateFor"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.clientId)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("button", {
                      type: "button",
                      class: { 'switcher-active': !_ctx.showInvoices },
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showInvoices = false))
                    }, _toDisplayString(_ctx.$t('receiptCreditCard.payments')), 3)
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode("button", {
                      type: "button",
                      class: { 'switcher-active': _ctx.showInvoices },
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showInvoices = true))
                    }, _toDisplayString(_ctx.$t('label.invoices')), 3)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isNew)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "add-payment-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openPaymentModal()))
              }, _toDisplayString(_ctx.$t('label.add-payment')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.showInvoices)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_7, [
              (_ctx.receipt.creditCardPelecardPayments?.length)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('receiptType.creditCard')), 1),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("table", null, [
                        _createVNode("thead", null, [
                          _createVNode("tr", null, [
                            _hoisted_11,
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.currency-rate')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receiptCreditCard.payments')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receiptCreditCard.lastFourDigits')), 1)
                            ]),
                            _createVNode("td", {
                              class: ["action-column", { 'action-column-end': !_ctx.isNew }]
                            }, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                            ], 2)
                          ])
                        ]),
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receipt.creditCardPelecardPayments, (crediCard, creditCardPaymentIndex) => {
                            return (_openBlock(), _createBlock("tr", { key: creditCardPaymentIndex }, [
                              _createVNode("td", null, _toDisplayString(creditCardPaymentIndex + 1), 1),
                              _createVNode("td", null, _toDisplayString(_ctx.formatAmount(crediCard.total)) + " " + _toDisplayString(_ctx.getCurrencySymbol(crediCard.currencyId)), 1),
                              _createVNode("td", null, _toDisplayString(crediCard.currencyRate), 1),
                              _createVNode("td", null, _toDisplayString(crediCard.numberOfPayments), 1),
                              _createVNode("td", null, _toDisplayString(crediCard.lastFourDigits), 1),
                              _createVNode("td", _hoisted_12, [
                                _createVNode("div", _hoisted_13, [
                                  _createVNode("span", null, _toDisplayString(_ctx.formatAmount((crediCard.total || 0) * crediCard.currencyRate)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.receipt.cashPayments?.length)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('receiptType.cash')), 1),
                    _createVNode("div", _hoisted_16, [
                      _createVNode("table", null, [
                        _createVNode("thead", null, [
                          _createVNode("tr", null, [
                            _hoisted_17,
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.currency-rate')), 1)
                            ]),
                            _createVNode("td", {
                              class: [{ 'action-column-end': !_ctx.isNew }, "action-column"]
                            }, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                            ], 2)
                          ])
                        ]),
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receipt.cashPayments, (cashPayment, cashPaymentIndex) => {
                            return (_openBlock(), _createBlock("tr", { key: cashPaymentIndex }, [
                              _createVNode("td", null, _toDisplayString(cashPaymentIndex + 1), 1),
                              _createVNode("td", null, _toDisplayString(_ctx.formatAmount(cashPayment.total)) + " " + _toDisplayString(_ctx.getCurrencySymbol(cashPayment.currencyId)), 1),
                              _createVNode("td", null, _toDisplayString(cashPayment.currencyRate), 1),
                              _createVNode("td", _hoisted_18, [
                                _createVNode("div", _hoisted_19, [
                                  _createVNode("span", null, _toDisplayString(_ctx.formatAmount((cashPayment.total || 0) * cashPayment.currencyRate)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                                  (_ctx.isNew)
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        class: "icon-f icon-pencil-edit fs-20",
                                        onClick: ($event: any) => (_ctx.editCashPayment(cashPaymentIndex))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isNew)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.removeCashPayment(cashPaymentIndex)),
                                        class: "icon"
                                      }, [
                                        _hoisted_20
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.receipt.checkPayments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('receiptType.check')), 1),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("table", null, [
                        _createVNode("thead", null, [
                          _createVNode("tr", null, [
                            _hoisted_24,
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.currency-rate')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receipt.bank')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receipt.branch')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('provider.accounting.number')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.check-no')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receipt.valueDate')), 1)
                            ]),
                            _createVNode("td", {
                              class: ["action-column", { 'action-column-end': !_ctx.isNew }]
                            }, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                            ], 2)
                          ])
                        ]),
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receipt.checkPayments, (checkPayment, checkPaymentIndex) => {
                            return (_openBlock(), _createBlock("tr", { key: checkPaymentIndex }, [
                              _createVNode("td", null, _toDisplayString(checkPaymentIndex + 1), 1),
                              _createVNode("td", null, _toDisplayString(_ctx.formatAmount(checkPayment.total)) + " " + _toDisplayString(_ctx.getCurrencySymbol(checkPayment.currencyId)), 1),
                              _createVNode("td", null, _toDisplayString(checkPayment.currencyRate), 1),
                              _createVNode("td", _hoisted_25, _toDisplayString(checkPayment.bankName), 1),
                              _createVNode("td", null, _toDisplayString(checkPayment.bankBranchNumber), 1),
                              _createVNode("td", null, _toDisplayString(checkPayment.accountNumber), 1),
                              _createVNode("td", null, _toDisplayString(checkPayment.checkNumber), 1),
                              _createVNode("td", null, _toDisplayString(checkPayment.valueDate), 1),
                              _createVNode("td", _hoisted_26, [
                                _createVNode("div", _hoisted_27, [
                                  _createVNode("span", null, _toDisplayString(_ctx.formatAmount((checkPayment.total || 0) * checkPayment.currencyRate)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                                  (_ctx.isNew)
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        class: "icon-f icon-pencil-edit fs-20",
                                        onClick: ($event: any) => (_ctx.editCheckPayment(checkPaymentIndex))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isNew)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.removeCheckPayment(checkPaymentIndex)),
                                        class: "icon"
                                      }, [
                                        _hoisted_28
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.receipt.bankTransferPayments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('receiptType.bankTransfer')), 1),
                    _createVNode("div", _hoisted_31, [
                      _createVNode("table", null, [
                        _createVNode("thead", null, [
                          _createVNode("tr", null, [
                            _hoisted_32,
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('label.currency-rate')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receipt.bank')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receipt.branch')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('provider.accounting.number')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('provider.account')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receipt.valueDate')), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('receiptBankTransfer.reference')), 1)
                            ]),
                            _createVNode("td", {
                              class: ["action-column", { 'action-column-end': !_ctx.isNew }]
                            }, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                            ], 2)
                          ])
                        ]),
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receipt.bankTransferPayments, (bankTransferPayment, bankTransferPaymentIndex) => {
                            return (_openBlock(), _createBlock("tr", { key: bankTransferPaymentIndex }, [
                              _createVNode("td", null, _toDisplayString(bankTransferPaymentIndex + 1), 1),
                              _createVNode("td", null, _toDisplayString(_ctx.formatAmount(bankTransferPayment.total)) + " " + _toDisplayString(_ctx.getCurrencySymbol(bankTransferPayment.currencyId)), 1),
                              _createVNode("td", null, _toDisplayString(bankTransferPayment.currencyRate), 1),
                              _createVNode("td", _hoisted_33, _toDisplayString(bankTransferPayment.bankName), 1),
                              _createVNode("td", null, _toDisplayString(bankTransferPayment.bankBranchNumber), 1),
                              _createVNode("td", null, _toDisplayString(bankTransferPayment.accountNumber), 1),
                              _createVNode("td", null, _toDisplayString(bankTransferPayment.providerAccountName), 1),
                              _createVNode("td", null, _toDisplayString(bankTransferPayment.valueDate), 1),
                              _createVNode("td", null, _toDisplayString(bankTransferPayment.referenceNumber), 1),
                              _createVNode("td", _hoisted_34, [
                                _createVNode("div", _hoisted_35, [
                                  _createVNode("span", null, _toDisplayString(_ctx.formatAmount((bankTransferPayment.total || 0) * bankTransferPayment.currencyRate)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                                  (_ctx.isNew)
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        class: "icon-f icon-pencil-edit fs-20",
                                        onClick: ($event: any) => (_ctx.editBankTransferPayment(bankTransferPaymentIndex))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isNew)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.removeBankTransferPayment(bankTransferPaymentIndex)),
                                        class: "icon"
                                      }, [
                                        _hoisted_36
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.paymentsExist)
              ? (_openBlock(), _createBlock("div", _hoisted_37, [
                  _createVNode("div", _hoisted_38, [
                    _createVNode("div", null, _toDisplayString(_ctx.$t('accounting.total')), 1),
                    _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.paymentsTotalAmount)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('label.invoices')), 1),
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode("table", _hoisted_42, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.invoice-number')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount')), 1)
                      ]),
                      (_ctx.isNew || _ctx.editMode)
                        ? (_openBlock(), _createBlock("th", _hoisted_43, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount-left-cover')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.amount-issue')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.created-date')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.creator-user')), 1)
                      ]),
                      (_ctx.isNew || _ctx.editMode)
                        ? (_openBlock(), _createBlock("th", _hoisted_44, [
                            _createVNode("div", _hoisted_45, [
                              _createVNode("div", {
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addModalReceipts && _ctx.addModalReceipts(...args)))
                              }, [
                                _hoisted_46
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receipt.invoices, (invoice, invoiceIndex) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: invoice.baseAccountingDocumentId
                      }, [
                        _createVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: {
                                                name: 'businessInvoiceView',
                                                params: { invoiceId: invoice.baseAccountingDocumentId, clientId: _ctx.clientId }
                                            },
                            class: "text-link",
                            target: "_blank"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(invoice.documentNumber), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createVNode("td", null, _toDisplayString(_ctx.formatAmount(invoice.amount)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                        (_ctx.isNew || _ctx.editMode)
                          ? (_openBlock(), _createBlock("td", _hoisted_47, _toDisplayString(_ctx.formatAmount(invoice.leftToCoverInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1))
                          : _createCommentVNode("", true),
                        _createVNode("td", null, [
                          (_ctx.isNew || _ctx.editMode)
                            ? (_openBlock(), _createBlock(_component_InputNumber, {
                                key: 0,
                                required: "",
                                class: "InputNumberByCover",
                                modelValue: invoice.amountToCover,
                                "onUpdate:modelValue": ($event: any) => (invoice.amountToCover = $event),
                                max: _ctx.getInvoiceAmountToCoverMax(invoice),
                                min: _ctx.getInvoiceAmountToCoverMin(invoice),
                                allowEmpty: false,
                                inputId: "locale-us",
                                locale: "en-US",
                                useGrouping: true,
                                suffix: ' ' + _ctx.localCurrencySymbol,
                                minFractionDigits: 2,
                                maxFractionDigits: 2
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "min", "suffix"]))
                            : (_openBlock(), _createBlock("span", _hoisted_48, _toDisplayString(_ctx.formatAmount(invoice.amountToCover)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1))
                        ]),
                        _createVNode("td", null, _toDisplayString(invoice.createdDate), 1),
                        _createVNode("td", null, _toDisplayString(invoice.creator), 1),
                        (_ctx.isNew || _ctx.editMode)
                          ? (_openBlock(), _createBlock("td", _hoisted_49, [
                              _createVNode("span", {
                                onClick: ($event: any) => (_ctx.removeRow(invoiceIndex)),
                                class: "icon"
                              }, [
                                _hoisted_50
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  (_ctx.invoicesCount)
                    ? (_openBlock(), _createBlock("tfoot", _hoisted_51, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_52, _toDisplayString(_ctx.invoicesCount) + " " + _toDisplayString(_ctx.$t('label.invoices').toLowerCase()), 1),
                          _createVNode("td", _hoisted_53, _toDisplayString(_ctx.formatAmount(_ctx.invoicesAmount)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                          (_ctx.isNew || _ctx.editMode)
                            ? (_openBlock(), _createBlock("td", _hoisted_54, _toDisplayString(_ctx.formatAmount(_ctx.invoicesAmountLeftToCover)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1))
                            : _createCommentVNode("", true),
                          _createVNode("td", {
                            class: "border-footer",
                            colspan: _ctx.isNew || _ctx.editMode ? 4 : 3
                          }, _toDisplayString(_ctx.formatAmount(_ctx.invoicesAmountToCover)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 9, ["colspan"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
    ], 512), [
      [_vShow, _ctx.loaded]
    ]),
    (_ctx.clientId)
      ? (_openBlock(), _createBlock(_component_BusinessReceiptInvoicesModal, {
          key: 0,
          clientId: _ctx.clientId,
          invoices: _ctx.businessInvoices,
          onAddInvoices: _ctx.addInvoices,
          localCurrencySymbol: _ctx.localCurrencySymbol,
          ref: "modalBusinessReceiptInvoices"
        }, null, 8, ["clientId", "invoices", "onAddInvoices", "localCurrencySymbol"]))
      : _createCommentVNode("", true),
    _createVNode(_component_BusinessReceiptPaymentModal, {
      isTerminalPaymentOnline: _ctx.isTerminalPaymentOnline,
      localCurrencyId: _ctx.localCurrencyId,
      onAddPaymentInReceipt: _ctx.addPaymentInReceipt,
      onClearCreditCard: _ctx.clearCreditCard,
      paymentCreditCardExist: _ctx.paymentCreditCardExist,
      localCurrencySymbol: _ctx.localCurrencySymbol,
      ref: "modalBusinessReceiptPayment"
    }, null, 8, ["isTerminalPaymentOnline", "localCurrencyId", "onAddPaymentInReceipt", "onClearCreditCard", "paymentCreditCardExist", "localCurrencySymbol"]),
    _createVNode(_component_BusinessReceiptPelecardPaymentModal, {
      ref: "modalBusinessReceiptPelecardPayment",
      onAddPaymentInReceiptFromIframe: _ctx.addPaymentInReceiptFromIframe
    }, null, 8, ["onAddPaymentInReceiptFromIframe"])
  ], 32))
})